import React, { useState, useEffect } from "react";
import { apiClient } from "../../../services/api/apiClient";
import {appInsights} from "../../../services/analytics/appInsights";
import { useMsal } from "@azure/msal-react";
import "./SpecTempSelectModal.css";

function SpecTempSelectModal({
  isOpen,
  onClose,
  title,
  onSubmit,
  pvfSubmittalId,
  propress,
  grooved,
  pvc,
  isContinuousAddingMode,
}) {
  const [selectedTemplate, setSelectedTemplate] = useState("none");
  const [templates, setTemplates] = useState([]);

  const { accounts } = useMsal();
  const userName = accounts && accounts[0] ? accounts[0].name : "Unknown";

  useEffect(() => {
    if (isOpen) {
      // Reset selected template for clean state
      setSelectedTemplate("none");

      const fetchTemplates = async () => {
        try {
          // Use apiClient for authenticated request, path should be relative to /api
          const response = await apiClient.get(
            `/templates/names?propress=${!!propress}&grooved=${!!grooved}&pvc=${!!pvc}`
          );
          // Extract data from the new standardized response format
          const templatesData = response?.data || [];
          setTemplates(templatesData);
        } catch (error) {
          console.error("Error fetching templates:", error);
          setTemplates([]);
        }
      };
      fetchTemplates();
    }
  }, [isOpen, propress, grooved, pvc]);

  if (!isOpen) {
    return null;
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (selectedTemplate && selectedTemplate !== "none") {
      try {
        // Find the actual template name from the templates array
        const selectedTemplateData = templates.find(
          (t) => t.value === selectedTemplate
        );
        const actualTemplateName = selectedTemplateData
          ? selectedTemplateData.name
          : selectedTemplate;

          // Track the creation of a spec from template and which template were used
          appInsights.trackEvent({
            name: 'SpecificationCreatedFromTemplate',
            properties: {
              template:actualTemplateName,
              user: userName,
            }
          });
        // Use apiClient for authenticated request, path should be relative to /api
        const response = await apiClient.get(
          `/templates?template=${encodeURIComponent(
            actualTemplateName
          )}&propress=${!!propress}&grooved=${!!grooved}&pvc=${!!pvc}`
        );

        console.log("here is the response from form submit", response);
        // Extract data from the new standardized response format
        const apiResponse = response.data;

        if (apiResponse && Object.keys(apiResponse).length > 0) {
          const templateKey = Object.keys(apiResponse)[0];
          const rawTemplateData = apiResponse[templateKey];

          // Transform the template data to match SpecificationFormModal's expected structure
          const preparedTemplateData = {
            id: null,
            name: rawTemplateData.name || actualTemplateName,
            sizes: rawTemplateData.details
              ? rawTemplateData.details.map((detail) => ({
                  ...detail,
                  id: null,
                  spec_id: null,
                  min_size_name: detail.min_size_name,
                  max_size_name: detail.max_size_name,
                  material_name: detail.material_name,
                  pipe_name: detail.pipe_name,
                  fitting_name: detail.fitting_name,
                  shutoff1_name: detail.shutoff1_name,
                  shutoff2_name: detail.shutoff2_name,
                  throttle_name: detail.throttle_name,
                  check_name: detail.check_name,
                  strainer_name: detail.strainer_name,
                  material_id: detail.material_id,
                  pipe_id: detail.pipe_id,
                  fitting_id: detail.fitting_id,
                  shutoff1_id: detail.shutoff1_id,
                  shutoff2_id: detail.shutoff2_id,
                  throttle_id: detail.throttle_id,
                  check_id: detail.check_id,
                  strainer_id: detail.strainer_id,
                  notes: detail.notes || "",
                  valves: detail.valves,
                }))
              : [],
            system_ids: rawTemplateData.system_ids || [],
            system_names: rawTemplateData.system_names || [],
            pvfsubmittal_id: pvfSubmittalId,
          };

          onSubmit(preparedTemplateData);
        } else {
          onSubmit(null);
        }
      } catch (error) {
        console.error("Error fetching or processing template:", error);
        alert(
          "Failed to load template. Proceeding with a blank specification."
        );
        onSubmit(null);
      }
    } else {
      onSubmit(null);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{title}</h2>
        <form onSubmit={handleFormSubmit}>
          <label htmlFor="template">Select a Template</label>
          <select
            id="template"
            name="template"
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(e.target.value)}
          >
            <option value="none">None</option>
            {templates.map((template) => (
              <option key={template.value} value={template.value}>
                {template.name}
              </option>
            ))}
          </select>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit">Create</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SpecTempSelectModal;
